/**
 * @author gyb(mocheer)
 * @since 2018-12-18
 */

let {
  LayerGroup,
  FeatureGroup
} = L;
let {
  addLayer
} = FeatureGroup.prototype

/**
 * 
 */
FeatureGroup.include({
  /**
   * 
   * @param {*} map 
   */
  onAdd(map) {
    this.eachLayer(map.addLayer, map);
    map.on('zoomend', this.checkByZoom, this)
  },
  /**
   * 
   * @param {*} map 
   */
  onRemove(map) {
    this.eachLayer(map.removeLayer, map);
    map.off('zoomend', this.checkByZoom, this);
  },
  /**
   * @param {*} layer
   */
  checkLayerInZoom(layer, flag) {
    let map = this._map;
    if (!map) {
      return;
    }
    let zoom = map.getZoom();
    //
    if (layer) {
      let {
        options
      } = layer;
      let outZoom = (options.minZoom && options.minZoom > zoom) || (options.maxZoom && options.maxZoom < zoom);
      let layers = this._layers_hide = this._layers_hide || {};
      if (outZoom) {
        layers[this.getLayerId(layer)] = layer;
        map.removeLayer(layer);
      } else if (this.getLayerId(layer) in layers || flag) {
        map.addLayer(layer);

      }
    }
    return this;
  },

  /**
   * @override
   */
  addLayer(layer) {
    if (this.hasLayer(layer)) {
      return this;
    }
    layer.addEventParent(this);
    var id = this.getLayerId(layer);
    this._layers[id] = layer;
    //
    this.checkLayerInZoom(layer, true);
    //
    return this.fire('layeradd', {
      layer: layer
    });
  },
  /**
   * 
   */
  checkByZoom() {
    this.eachLayer(this.checkLayerInZoom, this)
  }
})



// WEBPACK FOOTER //
// ./src/polyfill/FeatureGroup.js